
import { defineComponent, ref, computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { usePopupStore } from '@/store/popup'
import { useReadingResultStore, ReadingResultList } from '@/store/readingResult'

export default defineComponent({
  components: {
  },
  props:{
  },
  setup(props, {emit}) {
    const checkAll = ref(false);
    const popupStore = usePopupStore();
    const readingResultStore = useReadingResultStore();
    const readingResultList = computed(() => readingResultStore.getReadingResultList);
    const selectedListCount = computed(() => readingResultStore.getSelectedCount);

    const isTextTruncated = (el: HTMLElement) => {
      return el.scrollWidth > el.clientWidth;
    }

    const handleMouseEnterFileName = (e: MouseEvent, list: ReadingResultList) => {
      const target = e.currentTarget as HTMLElement;
      const related = e.relatedTarget as HTMLElement | null;

      if (!target.contains(related)) {
        list.showFileNameTooltip = isTextTruncated(target);
      }
    }

    const handleMouseLeaveFileName = (list: ReadingResultList) => {
      list.showFileNameTooltip = false;
    }

    const handleMouseEnterId = (e: MouseEvent, list: ReadingResultList) => {
      const target = e.currentTarget as HTMLElement;
      const related = e.relatedTarget as HTMLElement | null;

      if (!target.contains(related)) {
        list.showIdTooltip = isTextTruncated(target);
      }
    }

    const handleMouseLeaveId = (list: ReadingResultList) => {
      list.showIdTooltip = false;
    }

    const handleMouseEnterName = (e: MouseEvent, list: ReadingResultList) => {
      const target = e.currentTarget as HTMLElement;
      const related = e.relatedTarget as HTMLElement | null;

      if (!target.contains(related)) {
        list.showNameTooltip = isTextTruncated(target);
      }
    }

    const handleMouseLeaveName = (list: ReadingResultList) => {
      list.showNameTooltip = false;
    }

    const handleMouseEnterDate = (e: MouseEvent, list: ReadingResultList) => {
      const target = e.currentTarget as HTMLElement;
      const related = e.relatedTarget as HTMLElement | null;

      if (!target.contains(related)) {
        list.showDateTooltip = isTextTruncated(target);
      }
    }

    const handleMouseLeaveDate = (list: ReadingResultList) => {
      list.showDateTooltip = false;
    }

    const closePopup = () => {
      popupStore.togglePopup('resultList', false);
    }

    const selectAllList = (check: boolean) => {
      checkAll.value = check;

      for (let i = 0; i < readingResultList.value.length; i++) {
        readingResultList.value[i].selected = checkAll.value;
      }

      readingResultStore.getSelectedListCount();
    }

    const selectList = (list: any) => {
      list.selected = !list.selected;
      
      checkAll.value = true;
      for (let i = 0; i < readingResultList.value.length; i++) {
        if(!readingResultList.value[i].selected) {
          checkAll.value = false;
          break;
        }
      }

      readingResultStore.getSelectedListCount();
    }

    const deleteList = async (): Promise<void> => {
      if(selectedListCount.value > 0) {
        popupStore.togglePopup('deleteConfirm', true);
      }
    }

    const formatStudyDate = (date: string) => {
      if (/^\d{8}$/.test(date)) {
        return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
      }
      return date;
    };

     watch(readingResultList, (newVal) => {
      checkAll.value = false;
    });

    onMounted(() => {
      selectAllList(false);
    });

    return {
      closePopup,
      checkAll,
      readingResultList,
      selectAllList,
      selectList,
      deleteList,
      selectedListCount,
      formatStudyDate,
      isTextTruncated,
      handleMouseEnterFileName,
      handleMouseLeaveFileName,
      handleMouseEnterId,
      handleMouseLeaveId,
      handleMouseEnterName,
      handleMouseLeaveName,
      handleMouseEnterDate,
      handleMouseLeaveDate
    };
  },
});
